import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import {AttendeeEdit, AttendeeReadOnly} from './AttendeeForm';

function AttendeesPage({}: any) {
    return (
        <GenericCrudPage
            key='attendees-page'
            singularName='attendee'
            pageTitle='Attendees'
            resource='attendees'
            allowAdd={false}
            allowEdit={false}
            allowDelete={true}
            ReadOnlyComponent={AttendeeReadOnly}
            EditFormComponent={AttendeeEdit}
            allowPrint={true}
            newPayload={{
                title: '',
                name: '',
                about: '',
                type: 'attendee',
            }}
            validateFn={(data: any) => {
                const errorsList = [];
                if (!data) return;
                if (!data.name) errorsList.push('name is required');
                if (!data.title) errorsList.push('title is required');
                if (!data.mobile) errorsList.push('mobile is required');
                if (!data.email) errorsList.push('email is required');
                if (!data.about) errorsList.push('about is required');

                return [errorsList.length == 0, errorsList];
            }}
        />
    );
}

export default AttendeesPage;
